<template>
    <div class="energy-cost-container">
        <div class="search_wraps">
            <el-form
                class="leader-style-form leader-form-inner-tab-inline"
                :inline="true"
                :model="searchForm"
            >
                <el-form-item label="时间" style="float: left">
                    <el-date-picker
                        v-model="searchForm.time"
                        type="month"
                        placeholder="选择日期"
                        value-format="yyyy-MM"
                        format="yyyy-MM"
                        :picker-options="pickerOptions"
                        :clearable="false"
                        :editable="false"
                    ></el-date-picker>
                    <el-button
                        type="primary"
                        size="small"
                        style="margin-left: 40px"
                        @click="search"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-scrollbar style="height: 80%">
            <div class="consumption-wrap1">
                <!--            <h2 class="consump-title" style="margin-left: 40px">18个月能源成本</h2>-->
                <div class="consump-echarts-wrap">
                    <v-chart
                        :auto-resize="true"
                        :options="energyConsumpBar"
                        ref="energyConsumpBar"
                        theme="ovilia-green"
                        @click="consumpClick"
                    />
                </div>
            </div>

            <div class="two-div-wrap">
                <div class="left-div">
                    <!--                <h2 class="consump-title" style="margin-left: 40px">-->
                    <!--                    动能费用部门占比-->
                    <!--                </h2>-->
                    <!--                <div style="text-align: center; font-size: 16px;">-->
                    <!--                    {{ this.selectMonth }}月-->
                    <!--                </div>-->
                    <v-chart
                        :auto-resize="true"
                        :options="pie1"
                        ref="pie1"
                        theme="ovilia-green"
                        @click="pie1Click"
                    />
                </div>
                <div class="right-div">
                    <!--                <h2-->
                    <!--                    class="consump-title"-->
                    <!--                    style="float: right;margin-right: 50px;"-->
                    <!--                >-->
                    <!--                    动能费用类型占比-->
                    <!--                </h2>-->
                    <!--                <div-->
                    <!--                    style="text-align: center; font-size: 16px;margin-top:36px;"-->
                    <!--                >-->
                    <!--                    {{ this.selectMonth }}月-->
                    <!--                </div>-->
                    <v-chart
                        :auto-resize="true"
                        :options="pie2"
                        ref="pie2"
                        theme="ovilia-green"
                        @click="pie2Click"
                    />
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/treemap";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/graphic";
import * as api from "@/http/api.js";
import { departmentColor, sameAndCircle } from "@/utils/chart-color.js";
import utils from "@/utils/utils";
export default {
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            searchForm: {
                time: ""
            },
            selectMonth: "",
            selectTargetMainId: "",
            selectTargetUnitId: "",
            x_list: [],
            y_list: [],
            pie1Data1: [],
            pie1Data2: [],
            pie2Data: [],
            pie2Legend: []
        };
    },
    created() {
        this.getSysDate();
    },
    methods: {
        search() {
            this.getEnergyPriceList(this.searchForm.time);
        },
        getSysDate() {
            api.getSysDate1().then(res => {
                if (res && res.error_code === "0") {
                    this.searchForm.time = res.bus_json.sysdate3;
                    this.selectMonth = this.searchForm.time;
                    this.getEnergyPriceList(this.searchForm.time, "", "");
                    //获取左侧饼图
                    this.getAmountPriceByMonth(this.searchForm.time, "");
                    //获取右侧饼图
                    this.getAmountPriceByTarget(this.searchForm.time, "");
                }
            });
        },
        //获取柱状图
        getEnergyPriceList(time, target_main_id, target_unit_id) {
            api.getEnergyPriceList({
                show_time: this.searchForm.time,
                target_main_id: target_main_id,
                target_unit_id: target_unit_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.x_list = res.bus_json.months;
                    this.y_list = res.bus_json.amountList;
                }
            });
        },
        //获取左侧拼图
        getAmountPriceByMonth(time, target_main_id) {
            api.getAmountPriceByMonth({
                show_time: time,
                target_main_id: target_main_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.pie1Data1 = res.bus_json.parentPriceList;
                    this.pie1Data2 = res.bus_json.childPriceList;
                }
            });
        },
        //获取右侧饼图
        getAmountPriceByTarget(time, target_unit_id) {
            api.getAmountPriceByTarget({
                show_time: time,
                target_unit_id,
                target_unit_id
            }).then(res => {
                this.pie2Data = res.bus_json;
                this.pie2Legend = [];
                this.pie2Data.forEach(item => {
                    this.pie2Legend.push(item.name);
                });
            });
        },
        consumpClick(params) {
            this.selectMonth = params.name;
            this.getAmountPriceByMonth(this.selectMonth, "");
            this.getAmountPriceByTarget(this.selectMonth, "");
        },
        pie1Click(params) {
            this.selectTargetUnitId = params.data.target_unit_id;
            //柱状图
            this.getEnergyPriceList(
                this.selectMonth,
                "",
                this.selectTargetUnitId
            );
            //右侧饼图
            this.getAmountPriceByTarget(
                this.selectMonth,
                this.selectTargetUnitId
            );
        },
        pie2Click(params) {
            this.selectTargetMainId = params.data.target_main_id;
            //柱状图
            this.getEnergyPriceList(
                this.selectMonth,
                this.selectTargetMainId,
                ""
            );
            //左侧饼图
            this.getAmountPriceByMonth(
                this.selectMonth,
                this.selectTargetMainId
            );
        }
    },
    computed: {
        energyConsumpBar() {
            const option = {
                title: {
                    text: "18个月能源成本",
                    left: "center",
                    textStyle: {
                        color: utils.getFontColor() //字体颜色
                    }
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                    },
                    formatter: function (params) {
                        var tar = params[0];
                        console.log("1111111111111");
                        console.log(params);
                        // return "综合能耗:"+tar.data.value+"元";
                        return (
                            tar.axisValue +
                            "<br/>" +
                            "能源成本：" +
                            tar.data +
                            "元"
                        );
                    }
                },
                // legend: {
                //     data: ["综合能耗"],
                //     textStyle: { fontSize: 12, color: "#fff" }
                // },
                grid: {
                    left: "3%",
                    right: "2%",
                    bottom: "3%",
                    containLabel: true
                },
                xAxis: [
                    {
                        type: "category",
                        // axisLabel: {
                        //     color: "#5e8ac9",
                        //     fontSize: 14
                        // },
                        axisLabel: {
                            fontSize: 14,
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor() //颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        },
                        // axisLine: { lineStyle: { color: '#446594' } },
                        xAxisLeft: utils.getFontColor(),
                        data: this.x_list
                        // data: ['2019-12', '2020-01', '2020-02', '2020-03', '2020-04', '2020-05', '2020-06', '2020-07', '2020-08', '2020-09', '2020-10', '2020-11', '2020-12', '2021-01', '2021-02', '2021-03', '2021-04', '2021-05']
                    }
                ],
                yAxis: [
                    {
                        name: "元",
                        type: "value",
                        yAxisTop: "yellow",
                        nameTextStyle: {
                            color: utils.getFontColor(),
                            padding: 10
                        },
                        axisLabel: {
                            fontSize: 14,
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor() //颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                // type:'dashed',
                                color: utils.getFontColor()
                            }
                        },
                        xAxisLeft: utils.getFontColor()
                    }
                ],
                series: [
                    {
                        name: "综合电耗",
                        type: "bar",
                        itemStyle: {
                            normal: {
                                color: "#409eff"
                            }
                        },
                        data: this.y_list
                        // data:[0, 1516048.39, 1266799.19, 709187.6, 274418.24, 298309.91, 394146.64, 504618.81, 619017.77, 532769.94, 274418.24, 298309.91, 394146.64, 504618.81, 619017.77, 532769.94,0,455550]
                    }
                ]
            };
            return option;
        },
        pie1() {
            const option = {
                title: {
                    text: this.selectMonth + "月动能费用部门占比",
                    left: "center",
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{b}: {c}元({d}%)"
                },
                color: departmentColor,
                series: [
                    {
                        type: "pie",
                        selectedMode: "single",
                        radius: [0, "30%"],
                        label: {
                            position: "inner"
                        },
                        labelLine: {
                            show: false
                        },
                        data: this.pie1Data1
                        // data:[{
                        //     name:"电",
                        //     target_main_id:"111",
                        //     value:"80536.51",
                        // }]
                    },
                    {
                        type: "pie",
                        radius: ["40%", "60%"],
                        data: this.pie1Data2
                        // data: [{
                        //     name:"1#主变 4#主变",
                        //     target_main_id:"111",
                        //     value:"84",
                        // },{
                        //     name:"2#变 5#主变",
                        //     target_main_id:"111",
                        //     value:"10",
                        // },{
                        //     name:"3#变",
                        //     target_main_id:"111",
                        //     value:"6",
                        // }]
                    }
                ]
            };
            return option;
        },
        pie2() {
            const option = {
                title: {
                    text: this.selectMonth + "月动能费用类型占比",
                    left: "center",
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{b}: {c}元 ({d}%)"
                },
                color: departmentColor,
                legend: {
                    orient: "vertical",
                    left: "10%",
                    top: "30%",
                    textStyle: {
                        color: "#fff"
                    },
                    data: this.pie2Legend
                    // data: ["电"]
                },
                series: [
                    {
                        type: "pie",
                        selectedMode: "single",
                        radius: "55%",
                        center: ["50%", "60%"],

                        data: this.pie2Data,
                        // data: [{
                        //     name:"电",
                        //     target_main_id:"111",
                        //     value:"80536.51",
                        // }],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: utils.getFontColor()
                            }
                        }
                    }
                ]
            };
            return option;
        }
    }
};
</script>
<style lang="scss">
// .energy-cost-container::-webkit-scrollbar {
//     /*滚动条整体样式*/
//     height: 100%; /*高宽分别对应横竖滚动条的尺寸*/
//     width: 15px;
// }
// .energy-cost-container::-webkit-scrollbar-thumb {
//     /*滚动条里面小方块*/
//     border-radius: px2Rem(10px);
//     -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.2);
//     background: #348f9b;
// }
// .energy-cost-container::-webkit-scrollbar-track {
//     /*滚动条里面轨道*/
//     -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//     // border-radius: 10px;
//     background: #194f6d;
// }
.energy-cost-container {
    padding: px2Rem(20px);
    box-sizing: border-box;
    // background: transparent;
    width: 100%;
    height: 100%;
    overflow: auto;
    .search_wraps {
        margin: px2Rem(20px) 0 px2Rem(20px) px2Rem(20px);
        width: 100%;
        .time_btn {
            background: #29b85e;
            /*color: #fff;*/
            color: #ffff;
        }
    }
    .consump-title {
        font-size: 14px;
        text-indent: 1em;
        line-height: 36px;
        /*color: #fff;*/
        color: #ffff;
    }
    .consumption-wrap1 {
        width: 98%;
        height: px2Rem(400px);
        /*background: url(../../../../assets/image/leaderpage/kuai.png) no-repeat;*/
        /*color: #fff;*/
        color: #ffff;
        background-size: 100% 100%;
        .consump-echarts-wrap {
            width: 96%;
            height: 85%;
            // margin: 20px auto 20 auto;
            clear: both;
            .echarts {
                width: 100%;
                height: 100%;
            }
        }
    }
    .two-div-wrap {
        display: flex;
        margin-top: 20px;
        width: 98%;
        justify-content: space-between;
        .left-div {
            width: 49%;
            height: px2Rem(350px);
            /*background: url(../../../../assets/image/leaderpage/gou1.png)*/
            /*    no-repeat;*/
            /*color: #fff;*/
            color: #ffff;
            background-size: 100% 100%;
            .echarts {
                width: 100%;
                height: 100%;
            }
        }
        .right-div {
            width: 49%;
            height: px2Rem(350px);
            /*background: url(../../../../assets/image/leaderpage/gou2.png)*/
            /*    no-repeat;*/
            /*color: #fff;*/
            color: #ffff;
            background-size: 100% 100%;
            .echarts {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
